import DtoReferencial from './DtoReferencial'

export default class DtoAltimetrySystemObtentionMode extends DtoReferencial {
    constructor(obj) {
        super(obj)
    }
}
